export default __webpack_public_path__ + "static/logo-bert-kids-c5584fbf6b827723ff4b9ee9ddc68114.svg";